var BWalker = function (resList, node, pos) {
    resList.push({ node: node, pos: pos });
    return false;
};
/**
 * @param {boolean|nodesWalker} walker true for deep traversal, false for only direct child nodes, or custom walker
 */
var getNodesBetween = function (doc, from, to, walker) {
    if (walker === void 0) { walker = BWalker; }
    var nodes = [];
    doc.nodesBetween(from, to, function (node, pos, parent, index) { return walker(nodes, node, pos, parent, index); });
    return nodes;
};
var getNodesBefore = function (doc, pos) { return getNodesBetween(doc, 0, pos); };
var checkHasContent = function (nodes) {
    return nodes.some(function (_a) {
        var node = _a.node;
        return node.type !== node.type.schema.topNodeType.contentMatch.defaultType || node.nodeSize !== 2;
    });
};
var checkHasContentBefore = function (doc, pos) {
    // when the selection is at the head of the node, it's not the start of content, so -1
    var nodes = getNodesBefore(doc, pos > 0 ? pos - 1 : pos);
    return checkHasContent(nodes);
};
var getExistNodes = function (doc, nodeName) {
    var walker = function (res, curNode, pos) {
        if (curNode.type.name === nodeName) {
            res.push({
                node: curNode,
                pos: pos,
            });
        }
        return Boolean(curNode.content.childCount);
    };
    return getNodesBetween(doc, 0, doc.nodeSize - 2, walker);
};
// some nodes (break, etc.) have no text content and are replaced with spaces
var constructText = function (node) {
    if (node.textContent)
        return node.textContent;
    var len = node.nodeSize;
    var text = '';
    while (len--) {
        text += ' ';
    }
    return text;
};
var getExistMarks = function (state, markName) {
    var markType = state.schema.marks[markName];
    if (!markType)
        return [];
    var prevParent;
    var prevMark;
    var walker = function (res, curNode, pos, parent) {
        var cMark = curNode.marks.find(function (mark) { return mark.type.name === markName; });
        if (curNode.isLeaf && curNode.marks.length && markType.isInSet(curNode.marks)) {
            if (parent !== prevParent || cMark !== prevMark) {
                res.push({
                    pos: pos,
                    node: state.schema.text(constructText(curNode), curNode.marks),
                    mark: cMark,
                });
            }
            else if (cMark === prevMark) {
                var newNode = state.schema.text(res[res.length - 1].node.textContent + constructText(curNode), curNode.marks);
                res[res.length - 1].node = newNode;
            }
        }
        prevParent = parent;
        prevMark = cMark;
        return Boolean(curNode.content.childCount);
    };
    return getNodesBetween(state.doc, 0, state.doc.nodeSize - 2, walker);
};
var getCursorNode = function (view, depth) {
    var _a = view.state.selection, $from = _a.$from, $to = _a.$to;
    if ($from.parent !== $to.parent || $from.parent.type.name === 'doc')
        return false;
    return {
        pos: $from.before(depth),
        node: $from.node(depth),
    };
};
export { checkHasContentBefore, getCursorNode, getExistMarks, getExistNodes };
//# sourceMappingURL=query.js.map